import React, { useState } from "react";
import styled from "styled-components";
import { Jumbotron, Container, Row, Col } from "react-bootstrap";
import jumbowallpaper from "../img/wallpaper5.webp";
import blogs from "../data/blogs.js";
import BlogRes from "./BlogRes";

export default () => {
  const [selection, setSelection] = useState("");

  return (
    <Styles>
      <Jumbotron>
        <Container className="text-center">
          <h1 className="blog-heading">
            <i>Personal Blog</i>
          </h1>
        </Container>
      </Jumbotron>
      <Container>
        <Row>
          <Col md={8} xs={12}>
            {blogs.map((x) => (
              <BlogRes {...x} key={x.id} />
            ))}
          </Col>
          {/* For Scrolling */}
          <Col
            md={{ size: 4, order: "last" }}
            xs={{ size: 12, order: "first" }}
          >
            <div className="blog-titles">
              <h1>Blog Post</h1>
              <ul>
                {blogs.map((x) => (
                  <li key={x.id}>
                    <a
                      href={"#blog" + selection}
                      id={x.id}
                      onClick={(e) => setSelection(e.target.id)}
                    >
                      {x.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </Styles>
  );
};

const Styles = styled.div`
padding-top:5%;
margin-bottom:-10%;

.jumbotron {
    background-image: url(${jumbowallpaper});
    background-attachment: fixed;
    background-position: center left;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 64px 0px 0px 0px;
    min-height: 40vh;
    display: flex;
    align-items: center;
}
.blog-heading{
    font-size:350%;
    color:#45908b;
}

.blog-titles{
    position: fixed;
    border:1px solid #45908b;
    padding:1% 1% 1% 1%;
    margin-right:2%;
}
.blog-titles h1{
    color:#45908b;
}

@media (min-width: 2200px) {
    p, li{
        font-size: 120%
    }
    .blog-titles{
        font-size: 100%;
    }
    .blog-titles h1{
      font-size:160%;
    }
}

@media (max-width: 1024px) {
    padding-top:10%;
    .jumbotron {
        min-height: 30vh;
    }
    .blog-titles{
        a{
            font-size: 120%
        }
    } 
}

@media (max-width: 768px) {
    padding-top:10%;
    .blog-titles h1{
      font-size:140%;
    }
    .blog-titles a{
      font-size:100%;
    }
    h1{
      font-size:180%
    }
    h3{
      font-size:130%
    }
    p, li{
      font-size:85%
    }
}

@media (max-width: 736px) 
{
    padding-top:10%;
    .blog-titles{
        position: relative;
        background-color:white; 
    } 
}

@media (max-width: 576px) {
    padding-top:25%;
    margin-bottom:-5%;
    .blog-heading{
        font-size:250%;
    }
    .blog-titles{
        position: relative;
        background-color:white; 
        font-size: 70%;
    }
`;
